module.exports = __webpack_public_path__ + "static/img/college2.02fcd58.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Parters/college2.png
// module id = SVuA
// module chunks = 1